// @flow

import controller from 'fc-ctrl-layers'
import { token$ } from 'fc-auth'

export default controller({
  tree: 'layerData',
  branch: 'layers',
  token$,
})
